






































































import { Component, Vue, Provide, Watch } from 'vue-property-decorator'
import { localStore } from '@utils/storage'
import { Tabs, Tab, List } from 'vant'
import { isLogin as checkLogin, getSelectedCity, setSelectedCity, getSetCityServiceInH5 } from '@utils/index'
import { City, defaultCity } from '@app/core/constant/city'
import { getBabyList, getNetHomeData, HomeData, getStoreActivity } from './home-service'
import SearchTab from './components/search/search_tab.vue'
import RecommendTabs from './components/recommend/recommend_tabs.vue'
import selfSonSelecte from './components/selfSon/index.vue'
import { getPosition, getAgeType, setShareInfo, getDayjsObj, isSameHalfDay, setLoading } from '@utils/index'
import BigPromotion from './components/bigPromotion/index.vue'
import GridSection from './components/grid/index.vue'
import WishSection from './components/wish/index.vue'
import StoreHappy from './components/storeHappy/index.vue'
import DayPromotion from './components/dayPromotion/index.vue'
import CustomFloors from './components/customFloors/index.vue'
import CouponList from './components/couponList/index.vue'
import PromotionSection from './components/promotion/index.vue'
import BannerSection from './components/banner/index.vue'
import OrderBtn from './components/order/index.vue'
import SwitchCity from './components/switchCityDialog/index.vue'
import PopAd from './components/popAdDialog/index.vue'
import { isNumber, find, get, debounce } from 'lodash'
import { allowRefreshOrShare, unbind } from '@utils/index'

const SELECT_BABY = 'selectBaby'
const POPPED_TIME_AD = 'popped_time_ad' //上次弹窗广告时间
const POPPED_TIME_SC = 'popped_time_sc' //上次弹窗切换城市时间
enum DialogType {
  Login = 'AgeSelect',
  UnLogin = 'AgeSelectVisitor'
}

interface BabyInfo {
  age?: string
  local?: boolean //为true代表未登录的情况选择
  type: 1 | 2 | 3 //年龄段类型  1：孕期  2：0-36个月   3：36个月以上
}

interface mixinsEventInfo {
  scrollTop: number
  isTouch: boolean
}
const DEFAULT_BABY: BabyInfo = { type: 2, age: '0-3岁' } //默认0-3岁 也就是type==2

window._TRACK_EXPOSURE = true //当前页面开启自动曝光监控（在引入sdk前设置）

@Component({
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [List.name]: List,
    SearchTab,
    RecommendTabs,
    selfSonSelecte,
    BigPromotion, //大促位
    GridSection,
    WishSection, //心愿单
    CouponList, // 优惠券
    PromotionSection,
    DayPromotion,
    CustomFloors, // 自定义可扩展楼层
    StoreHappy,
    BannerSection,
    OrderBtn,
    SwitchCity, // 切换到定位城市
    PopAd, // 弹窗广告
    AgeSelectVisitor: () => import('./components/ageSelectDialogVisitor/index.vue'), //游客
    AgeSelect: () => import('./components/ageSelectDialog/index.vue')
  }
})
export default class Home extends Vue {
  tabKey = 0 //每次选择宝宝后加1  出发searchTab组件重新获取高度
  titleBarHeight = 0 //titleBar的高度  用来计算tab的吸顶offsettop
  templateType = 2 //templateType 1：个性化 2：通用
  timerId = -1
  location: any = null
  isLogin = false
  babyList: any[] = [] //宝宝列表 登陆才会去请求
  selectedBaby: BabyInfo | null = null //已经选择的宝宝
  babyDialog = '' //选择宝宝弹框类型 分未登录和登陆
  babyDialogShow = false //宝宝弹框是否显示
  cityInfo: City = defaultCity
  isLoadFirst = false //默认一开始不加载组件 因为首页会多一次请求
  homeData: HomeData | null = null
  storeActivity: any = null //
  errormsg = '' //不为空 就实现错误页面
  isSupport = true //是否支持该城市
  isShowPopup = false //是否显示气泡 （未登录且没有选择宝宝）
  isShowSwitchCity = false //是否显示切换城市弹窗（默认首页收货地址所在的城市A与用户实时定位的城市B不一致时）
  isShowPopAd = false //是否显示弹窗广告
  showServiceIcon = true //是否显示服务咨询图标
  isTint = false // 育儿顾问图标浅色
  left = 0 // 滑动距离
  oldScrollTop = 0 //记录上一次滚动结束后的滚动距离
  scrollTop = 0 // 记录当前的滚动距离
  isTouch = false // 正在滑动
  scrollTimeout = 0 // 滑动延时器

  getValue = get

  @Provide()
  pageTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012974',
    pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }
  }
  @Provide()
  clickid_200001 = '200015'
  @Provide()
  clickid_200003 = '200015'
  @Provide()
  clickid_200002 = '200014'
  @Provide()
  clickid_200005 = '200014'
  @Provide()
  clickid_home_product = '200014'

  @Provide()
  clickid_tab = '200012'
  @Provide()
  clickid_city = '200017'
  @Provide()
  clickid_search = '200001'

  @Provide()
  clickid_tab_business = '200028'
  @Provide()
  clickid_tab_product = '200027'
  @Provide()
  clickid_recieve_coupon = '200029'
  @Provide()
  clickid_use_coupon = '200030'
  @Provide()
  clickid_selfson_product = '200031'

  @Watch('cityInfo')
  cityInfoChanged(city: City) {
    this.pageTrackParams.pageParam.citycode = city.cityId
  }

  @Watch('templateType')
  siteidChanged(type: number) {
    this.pageTrackParams.pageParam.siteid = type
  }

  @Watch('mixinsEvent')
  scrollTopChanged(newValue: mixinsEventInfo, oldValue: mixinsEventInfo) {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
    this.scrollTimeout = setTimeout(() => {
      if (newValue.scrollTop == window.scrollY && !this.isTouch) {
        this.isTint = false
        this.left = 0
        this.oldScrollTop = newValue.scrollTop
      }
    }, 300)
    if (this.oldScrollTop == oldValue.scrollTop) {
      this.isTint = true
      this.left = 52
    }
  }

  handleScroll(that: any) {
    return debounce(() => {
      that.scrollTop = window.scrollY
    }, 50)
  }

  async created() {
    setLoading()
    // const that = this
    // window.addEventListener('scroll',     debounce(() => {
    //    this.scrollTop = window.scrollY
    //  }, 50))
    window.addEventListener('scroll', this.handleScroll(this))

    allowRefreshOrShare(false)
    setShareInfo({
      title: '孩子王孕产亲子服务',
      desc: '月嫂/产康/摄影/早教/亲子…为您优选母婴童服务'
    })
    //获取城市
    this.cityInfo = await getSelectedCity()
    try {
      // TODO test comment it
      this.location = await getPosition(false)
      // this.location = {
      //   lat: '32.020462125774095',
      //   lng: '118.89281287070841'
      // }
      this.tabKey++ //重新请求搜索
      // 初始化显示切换城市与弹窗广告
      const showResult = this.initShowSwitchCity()
      !showResult && this.initShowPopAd()
    } catch (error) {
      console.log('定位失败')
    }
    this.isLogin = checkLogin()
    //登陆情况下的选择宝宝组件
    if (this.isLogin) {
      try {
        this.babyList = await getBabyList()
      } catch (error) {}
    }
    //首先获取默认0-3岁的数据  不加载搜索view
    await this.getHomeData(false)
    setLoading(false)
    this.homeData?.isSelfSon && this.homeData?.title ? this.$setTitle(this.homeData.title) : this.$setTitle('孕产·亲子·教育')
    this.$newViewTracker({ ...this.pageTrackParams })
    if (this.templateType === 1) {
      const saveBaby = localStore.getItem(SELECT_BABY)
      if (this.isLogin) {
        const addNew = this.$route.query.hasOwnProperty('addnewbaby')
        if (addNew) {
          //清除query中的值 todo
          this.$router.replace({ query: {} })
        }
        try {
          this.babyDialog = DialogType.Login
          if (this.babyList.length === 0) {
            //未添加过宝宝的情况
            localStore.removeItem(SELECT_BABY)
            //延迟1s弹框
            this.timerId = setTimeout(() => {
              this.babySelect()
            }, 1000)
          } else {
            let baby: any = null
            //当没有选择过宝宝 或者选择过 但是是未登录选择 或者刚刚新增过宝宝  统一取第一个最新的宝宝
            if (!saveBaby || saveBaby.local || addNew) {
              baby = this.babyList[this.babyList.length - 1]
            } else {
              baby = find(this.babyList, item => item.bid === saveBaby.bid)
              //没有命中 默认选最新
              if (!baby) {
                baby = this.babyList[this.babyList.length - 1]
              }
            }
            if (baby) {
              this.selectedBaby = { ...baby, local: false, type: getAgeType(baby.birthday, baby.nickname) }
              localStore.setItem(SELECT_BABY, this.selectedBaby)
            }
          }
        } catch (error) {
          //获取宝宝列表失败后情况下的选择宝宝组件
          this.babyDialog = DialogType.UnLogin
        }
      } else {
        //未登陆情况下的选择宝宝组件
        this.babyDialog = DialogType.UnLogin
        //发现没有选择宝宝  获取是在登陆情况下已经选择的  统一按默认来处理
        if (!saveBaby || !saveBaby.local) {
          localStore.removeItem(SELECT_BABY)
          //过10s自动消失
          this.isShowPopup = true
          this.timerId = setTimeout(() => {
            this.isShowPopup = false
          }, 10 * 1000)
        } else {
          this.selectedBaby = saveBaby
        }
      }
      if (this.selectedBaby != null && this.selectedBaby.type !== DEFAULT_BABY.type) {
        //再获取一次数据
        this.refresh()
      } else {
        this.loadUI()
      }
    } else {
      this.loadUI()
    }
    // try {
    //   this.location = await getPosition(false)
    //   this.tabKey++ //重新请求搜索
    //   // 初始化显示切换城市与弹窗广告
    //   const showResult = this.initShowSwitchCity()
    //   !showResult && this.initShowPopAd()
    // } catch (error) {
    //   console.log('定位失败')
    // }
  }

  mounted() {
    const titleBar = this.$refs.titlebar as Vue
    const rect = titleBar.$el.getBoundingClientRect()

    this.titleBarHeight = rect.height - 1 //-1兼容性问题
  }

  beforeDestroy() {
    if (this.timerId > -1) {
      clearTimeout(this.timerId)
      this.timerId = -1
    }
    unbind()
  }

  get channelExposure() {
    return `200002||${JSON.stringify({ citycode: this.cityInfo.cityId })}`
  }
  channelClick(channel: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200002', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId, name: channel.channelName } })
  }

  get wishExposure() {
    return `200004||${JSON.stringify({ citycode: this.cityInfo.cityId })}`
  }
  wishClick() {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200004', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId } })
  }

  get bannerExposure() {
    return `200011||${JSON.stringify({ citycode: this.cityInfo.cityId })}`
  }
  bannerClick(banner: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200011', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId, link: banner.linkUrl, name: banner.adsenseName } })
  }

  @Provide()
  toPanicBuyEP = (params = {}) => {
    return `200005||${JSON.stringify({ ...params })}`
  }
  toPanicBuy(spuid: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200005', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { spuid: spuid } })
  }

  @Provide()
  toChoiceEP = (params = {}) => {
    return `200006||${JSON.stringify({ ...params })}`
  }
  toChoice(spuid: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200006', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { spuid: spuid } })
  }

  @Provide()
  operateEP = (params = {}) => {
    return `200007||${JSON.stringify({ citycode: this.cityInfo.cityId, ...params })}`
  }
  operateClick(item: any) {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200007', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId, link: item.linkUrl, name: item.adsenseName } })
  }

  customFloorItemClick(params: any) {
    const title = params?.item?.title || params?.columGroup?.title || ''
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200037', pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId, name: title || ''  } })
  }

  trackClick(params: any){
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: params.clickId, pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { citycode: this.cityInfo.cityId, name: params.name || ''  } })
  }

  get searchExposure() {
    return `${this.clickid_tab}||${JSON.stringify({ citycode: this.cityInfo.cityId })}`
  }

  get recommendExposure() {
    return `${this.clickid_tab}||${JSON.stringify({ citycode: this.cityInfo.cityId })}`
  }

  get mixinsEvent() {
    return {
      scrollTop: this.scrollTop,
      isTouch: this.isTouch
    }
  }

  //获取首页数据
  async getHomeData(isLoadFirst = true) {
    // let { type = 2 } = this.selectedBaby || {}
    this.isSupport = true
    this.errormsg = ''
    let birthday = ''
    let ageFilter = 2
    if (this.babyList && this.babyList.length > 0) {
      const baby = this.babyList.find(item => +item.isDefault === 1)
      if (+baby.babystate === 2) {
        birthday = baby.birthday || ''
        ageFilter = 2
      }
    }
    try {
      // this.homeData = await getNetHomeData(type, this.cityInfo.cityId, 2)
      const params = {
        ageFilter,
        cityId: this.cityInfo.cityId,
        versionType: 3,
        birthday,
        longitude: this.location?.lng,
        latitude: this.location?.lat
      }
      this.homeData = await getNetHomeData(params)
      //获取门店趣玩数据
      if (this.location?.lat && this.location?.lng) {
        getStoreActivity({
          cityId: this.cityInfo.cityId,
          lat: this.location?.lat,
          lng: this.location?.lng
        }).then(data => {
          if (data) {
            this.storeActivity = data
          }
        })
      }

      this.templateType = this.homeData.templateType
      if (isLoadFirst) {
        //加载UI
        this.loadUI()
      }
    } catch (error) {
      if (isNumber(error) && error === 10002) {
        this.isSupport = false
      } else {
        this.errormsg = error as string
      }
    }
  }

  loadUI() {
    if (!this.isSupport) return
    this.$nextTick(() => {
      //不用nextTick会多调一次搜索接口
      this.isLoadFirst = true
      this.$nextTick(() => {
        window.scrollTo(0, 0) //滑动到顶部
      })
    })
  }

  babySelect() {
    this.isShowPopup = false
    this.babyDialogShow = true
  }

  //宝宝选择成功
  async babySelected(age: any) {
    if (age.local) {
      this.selectedBaby = age
    } else {
      this.selectedBaby = { ...age, local: false, type: getAgeType(age.birthday, age.nickname) }
    }
    localStore.setItem(SELECT_BABY, this.selectedBaby)
    this.babyDialogShow = false
    this.refresh()

    const eventId = age.local ? '200003' : '200016'
    const posParamTitle = age.local ? age.age : age.birthdiscribe
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: eventId, pageParam: { citycode: this.cityInfo.cityId, siteid: this.templateType }, positionParam: { title: posParamTitle } })
  }

  //城市切换成功
  async citySwitched(city: any) {
    this.isShowSwitchCity = false
    setSelectedCity(city.cityId, city.cityName, location.href)
    location.reload()
  }
  //未切换城市
  cityUnSwitched() {
    this.isShowSwitchCity = false
    this.initShowPopAd()
  }

  //初始化是否显示切换城市
  initShowSwitchCity() {
    /* 所选城市与定位城市不一致时提示需要切换城市弹窗 */
    if (this.location && this.location.cityId && this.cityInfo && this.location.cityId !== this.cityInfo.cityId && this.isSupport) {
      // 所选城市是用户当天在h5中手动选的，非APP设置的，不显示弹窗。
      const setCityInH5 = getSetCityServiceInH5()
      const setCity = setCityInH5.setCity
      const setTime = setCityInH5.setTime
      if (setCity == this.cityInfo.cityId && setTime) {
        const setDayjsObj = getDayjsObj(+setTime)
        const nowDayjsObj = getDayjsObj()
        const sameDay = setDayjsObj.format('YYYY-MM-DD') === nowDayjsObj.format('YYYY-MM-DD')
        if (sameDay) {
          return false
        }
      }
      let needPop = true
      const poppedTime: string = localStore.getItem(POPPED_TIME_SC)
      const FORM = 'YYYY-MM-DD HH:mm:ss'
      if (poppedTime) {
        const poppedDayjsObj = getDayjsObj(poppedTime, FORM)
        const nowDayjsObj = getDayjsObj()
        const sameDay = poppedDayjsObj.format('YYYY-MM-DD') === nowDayjsObj.format('YYYY-MM-DD')
        if (sameDay) {
          // 同一天内，不显示弹窗
          needPop = false
        }
      }
      if (needPop) {
        const nowTime: string = getDayjsObj().format(FORM)
        localStore.setItem(POPPED_TIME_SC, nowTime)
        this.isShowSwitchCity = true
      }
      return needPop
    }
    return false
  }

  //初始化是否显示弹窗广告
  initShowPopAd() {
    if (this.homeData?.ads?.popads) {
      const popad = this.homeData.ads.popads[0]
      if (popad) {
        let needPop = true
        const poppedTime: string = localStore.getItem(POPPED_TIME_AD)
        const FORM = 'YYYY-MM-DD HH:mm:ss'
        if (poppedTime) {
          const poppedDayjsObj = getDayjsObj(poppedTime, FORM)
          const sameHalfDay = isSameHalfDay(poppedDayjsObj)
          if (sameHalfDay) {
            // 同一半天内，不显示弹窗
            needPop = false
          }
        }
        if (needPop) {
          const nowTime: string = getDayjsObj().format(FORM)
          localStore.setItem(POPPED_TIME_AD, nowTime)
          this.isShowPopAd = true
        }
        return needPop
      }
    }
    return false
  }

  //刷新接口 同事更新sticky高度
  async refresh() {
    await this.getHomeData()
    //通知tab重新获取sticky高度
    this.tabKey++
  }

  startMove() {
    this.isTouch = true
    // this.isTint = true
    // this.left = 44
  }

  endMove() {
    this.isTouch = false
    // this.isTint = false
    // this.left = 0
  }

  goServiceLink() {
    this.$newClickTracker({ bizType: '127', pageLevelId: '121012974', clickId: '200032', pageParam: { citycode: this.cityInfo.cityId }, positionParam: { citycode: this.cityInfo.cityId } })
    location.href = this.homeData?.customService?.link as string
  }

  /*
  icon支持展示1行或2行，每行最多显示5个图标，不同icon数量显示规则如下：
  ● 等于4、5个时：显示一行
  ● 小于4个时：全部不显示
  ● 等于6、7、8个时：只显示排序前5
  ● 等于9、10个时：显示为2行
  ● 大于10个时：只显示排序前10
  */
  get gridRows() {
    const channel = this.homeData?.channel || []
    if (channel.length < 4) {
      return 0
    }
    if (channel.length > 4 && channel.length <= 8) {
      return 1
    } else {
      return 2
    }
  }

  get showBigPromotion() {
    const bigpromote = this.homeData?.ads?.bigpromote
    if (bigpromote) {
      return bigpromote.length > 0
    }
    return false
  }

  get showGrid() {
    const channel = this.homeData?.channel
    if (channel && channel.length > 3) {
      return true
    }
    return false
  }

  get showWish() {
    const forceful = this.homeData?.ads?.forceful
    if (forceful) {
      return true
    }
    return false
  }

  get showPromotion() {
    const operate = this.homeData?.ads?.operate
    if (this.homeData?.promotion || this.homeData?.custom || (operate && operate.length > 0)) {
      return true
    }
    return false
  }

  get showBanner() {
    const carousel = this.homeData?.ads?.carousel
    if (carousel) {
      return true
    }
    return false
  }

  selectCity() {
    this.$router.push({ name: 'city-choose', query: { referer: encodeURIComponent(location.href), refresh: 'no' } })
  }

  destory() {
    window.removeEventListener('scroll', this.handleScroll)
    clearTimeout(this.scrollTimeout)
  }
}
